import "./Basket.scss";
import Alert from "../../../../shared/UIComponents/Alert";
import AlertSecondary from "../../../../shared/UIComponents/AlertSecondary/AlertSecondary";
import {useEffect, useState} from "react";
import {Purchase} from "./interfaces";
import NoItems from "./components/NoItems/NoItems";
import {getPurchases} from "./components/requests";
import ActivatedServices from "./components/ActivatedServices/ActivatedServices";
import BasketItems from "./components/BasketItems/BasketItems";

const Basket = () => {
    const [purchasesServices, setPurchasesServices] = useState<Purchase[]>([])
    const [purchasesProducts, setPurchasesProducts] = useState<Purchase[]>([])

    const fetchPurchases = () => {
        getPurchases(setPurchasesServices, setPurchasesProducts)
    }

    useEffect(() => {
        fetchPurchases()
    }, [])

    return (
        <div className="basket-wrapper">
            <Alert text={"Щоб забрати товар у грі, натисніть кнопку \"u\""}/>
            <AlertSecondary text={"Товари нижче можна повернути або один раз змінити сервер видачі"} />
            <ActivatedServices purchasesServices={purchasesServices} onRefresh={fetchPurchases} />
            <BasketItems purchasesProducts={purchasesProducts} setPurchasesProducts={setPurchasesProducts} />
            <NoItems purchasesProducts={purchasesProducts} purchasesServices={purchasesServices} />
        </div>
    );
};

export default Basket;